import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M27.747 13.336a1 1 0 0 1-.083 1.411l-9 8a1 1 0 0 1-1.328 0l-9-8a1 1 0 0 1 1.328-1.494L18 20.663l8.336-7.41a1 1 0 0 1 1.411.083",
		clipRule: "evenodd"
	})
});
export default SvgIcoChevronDown;
